import defaultTheme from 'tailwindcss/defaultTheme';

export const DEFAULT_ADVANCE_BUTTON_STYLE =
  'bg-indigo enabled:hover:bg-violet-600 text-white rounded text-sm font-bold py-2 px-5 disabled:opacity-25';
export const DEFAULT_CANCEL_BUTTON_STYLE =
  'bg-grey-1 enabled:hover:bg-grey-2 text-black rounded text-sm font-bold py-2 px-5 disabled:opacity-25';
export const DEFAULT_DANGER_BUTTON_STYLE =
  'bg-red enabled:hover:bg-orange text-white rounded text-sm font-bold py-2 px-5 disabled:opacity-25';
export const RAISED_DIALOG = 'm-auto bg-white rounded-xl border shadow-lg p-8';
export const INPUT_STYLE =
  'w-full h-[2.5rem] border border-gray-300 bg-white rounded-md focus:ring-blue-500 focus:border-blue-500 p-2';
export const SELECT_INPUT_STYLE =
  'flex w-[20rem] m-auto py-2 px-4 my-4 text-[14px] text-gray-700 leading-tight border border-gray-300 rounded-md bg-white focus:outline-none focus:shadow-outline-blue';
export const BORDER_STYLE = 'border border-1 border-grey-2 rounded-lg';
export const DEFAULT_MINI_TABLE_SX_STYLES = {
  '.MuiDataGrid-cell': {
    color: '#161616',
    fontFamily: ['"Helvetica Neue"', '"Segoe UI"', '"Ariel"', ...defaultTheme.fontFamily.sans].join(','),
    '.MuiInputBase-root': { maxHeight: '100%' },
    '.MuiBox-root': { padding: '0' },
    '.MuiPickersOutlinedInput-notchedOutline': { border: 'none' }
  },
  '.MuiDataGrid-columnHeader': {
    fontFamily: ['"Helvetica Neue"', '"Segoe UI"', '"Ariel"', ...defaultTheme.fontFamily.sans].join(','),
    fontSize: '.75rem',
    fontWeight: 'bold',
    color: '#606060'
  },
  '.MuiDataGrid-columnHeaders': {
    position: 'sticky',
    top: 0
  },
  '.MuiDataGrid-columnHeaders div[role="row"]': {
    backgroundColor: '#F7F7F7'
  },
  '.grey-background': {
    backgroundColor: '#F7F7F7',
    fontWeight: 'bold',
    fontSize: '.75rem'
  },
  headerHeight: 40,
  borderWidth: '0',
  borderBottomLeftRadius: '.75rem',
  borderBottomRightRadius: '.75rem'
};
export const DEFAULT_TABLE_STYLES = {
  sx: {
    height: '74vh',
    '.MuiDataGrid-cell': {
      color: '#161616',
      fontFamily: ['"Helvetica Neue"', '"Segoe UI"', '"Ariel"', ...defaultTheme.fontFamily.sans].join(','),
      '.MuiInputBase-root': { maxHeight: '100%' },
      '.MuiBox-root': { padding: '0' },
      '.MuiPickersOutlinedInput-notchedOutline': { border: 'none' }
    },
    '.MuiDataGrid-columnHeader': {
      fontFamily: ['"Helvetica Neue"', '"Segoe UI"', '"Ariel"', ...defaultTheme.fontFamily.sans].join(','),
      fontSize: '.75rem',
      color: '#606060'
    },
    '.MuiDataGrid-toolbar': {
      margin: '7px 0',
      borderBottom: 'none'
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderRadius: '0',
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none'
    },
    flex: 1
  },
  headerHeight: 40,
  rowHeight: 40
};
export const DEFAULT_INLINE_TAB_SX_STYLES = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'rgb(247 247 247)',
  borderBottom: '1px solid rgb(229 231 235)',
  paddingRight: '6rem',
  maxWidth: '100%'
};
export const DEFAULT_TAB_SX_STYLES = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'rgb(247 247 247)',
  borderBottom: '1px solid rgb(229 231 235)',
  borderTop: '1px solid rgb(229 231 235)',
  paddingRight: '6rem',
  maxWidth: '100%',
  marginTop: '.5rem'
};
